// extracted by mini-css-extract-plugin
export default {"battery":"BatteryCharge_battery__atyO8","batteryValue":"BatteryCharge_batteryValue__yQEwx"};